import { jsx as r } from "react/jsx-runtime";
import { cva as u } from "class-variance-authority";
import { cn as n } from "../../lib/utils.js";
import { Button as d } from "./button.js";
import { Input as l } from "./input.js";
import { Textarea as p } from "./textarea.js";
function k({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: n(
        "group/input-group relative flex h-8 w-full min-w-0 items-center rounded-lg border border-input transition-colors outline-none in-data-[slot=combobox-content]:focus-within:border-inherit in-data-[slot=combobox-content]:focus-within:ring-0 has-disabled:bg-input/50 has-disabled:opacity-50 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-3 has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-3 has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>textarea]:h-auto dark:bg-input/30 dark:has-disabled:bg-input/80 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 has-[>[data-align=block-end]]:[&>input]:pt-3 has-[>[data-align=block-start]]:[&>input]:pb-3 has-[>[data-align=inline-end]]:[&>input]:pr-1.5 has-[>[data-align=inline-start]]:[&>input]:pl-1.5",
        a
      ),
      ...t
    }
  );
}
const c = u(
  "flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4",
  {
    variants: {
      align: {
        "inline-start": "order-first pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem]",
        "inline-end": "order-last pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem]",
        "block-start": "order-first w-full justify-start px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2",
        "block-end": "order-last w-full justify-start px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function z({
  className: a,
  align: t = "inline-start",
  ...i
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: n(c({ align: t }), a),
      onClick: (e) => {
        var o, s;
        e.target.closest("button") || (s = (o = e.currentTarget.parentElement) == null ? void 0 : o.querySelector("input")) == null || s.focus();
      },
      ...i
    }
  );
}
const g = u(
  "flex items-center gap-2 text-sm shadow-none",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 rounded-[calc(var(--radius)-3px)] px-1.5 [&>svg:not([class*='size-'])]:size-3.5",
        sm: "",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function w({
  className: a,
  type: t = "button",
  variant: i = "ghost",
  size: e = "xs",
  ...o
}) {
  return /* @__PURE__ */ r(
    d,
    {
      type: t,
      "data-size": e,
      variant: i,
      className: n(g({ size: e }), a),
      ...o
    }
  );
}
function y({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "span",
    {
      className: n(
        "flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        a
      ),
      ...t
    }
  );
}
function G({
  className: a,
  ...t
}) {
  return /* @__PURE__ */ r(
    l,
    {
      "data-slot": "input-group-control",
      className: n(
        "flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        a
      ),
      ...t
    }
  );
}
function I({
  className: a,
  ...t
}) {
  return /* @__PURE__ */ r(
    p,
    {
      "data-slot": "input-group-control",
      className: n(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-2 shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        a
      ),
      ...t
    }
  );
}
export {
  k as InputGroup,
  z as InputGroupAddon,
  w as InputGroupButton,
  G as InputGroupInput,
  y as InputGroupText,
  I as InputGroupTextarea
};
//# sourceMappingURL=input-group.js.map
